import { render, staticRenderFns } from "./SendBidModal.vue?vue&type=template&id=5f1e4bde&"
import script from "./SendBidModal.vue?vue&type=script&lang=js&"
export * from "./SendBidModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports